import { Alert, Snackbar, SnackbarOrigin } from "@mui/material";

import {
  DeleteAllotmentPolicies,
  EditAllotmentPoliciesLocationValues,
} from "../../../redux/slices/grainTracker/grainTrackerTypes";
import { stylesGW } from "../grainWiseStylesMUIComponents";

export const ShowsMessagesSuccess = (
  t: (arg0: string) => string,
  editBinAllotment: EditAllotmentPoliciesLocationValues,
  editBins: EditAllotmentPoliciesLocationValues,
  deleteAllotmentPolicies: DeleteAllotmentPolicies
) => {
  const showErrorOrValidation = (success: boolean, error: string) => {
    if (success) {
      return { show: true, severity: "success" };
    }
    if (error) {
      return { show: true, severity: "error" };
    }
    return undefined;
  };

  return (
    <div>
      <Snackbar
        open={
          showErrorOrValidation(editBins.editedDone, editBins.editedError)?.show
        }
        autoHideDuration={6000}
        anchorOrigin={
          stylesGW.ShowsMessagesSuccess.anchorOrigin as
            | SnackbarOrigin
            | undefined
        }
      >
        <Alert
          severity={
            showErrorOrValidation(editBins.editedDone, editBins.editedError)
              ?.severity as any
          }
          variant="filled"
          sx={stylesGW.ShowsMessagesSuccess.alert}
        >
          {t("Grain_tracker.changes_location_saved")}
        </Alert>
      </Snackbar>

      <Snackbar
        open={
          showErrorOrValidation(
            editBinAllotment.editedDone,
            editBinAllotment.editedError
          )?.show
        }
        autoHideDuration={6000}
        anchorOrigin={
          stylesGW.ShowsMessagesSuccess.anchorOrigin as
            | SnackbarOrigin
            | undefined
        }
      >
        <Alert
          severity="success"
          variant="filled"
          sx={stylesGW.ShowsMessagesSuccess.alertSucces}
        >
          {t("Grain_tracker.new_criteria")}
        </Alert>
      </Snackbar>

      <Snackbar
        open={
          showErrorOrValidation(
            deleteAllotmentPolicies.deleteDone,
            deleteAllotmentPolicies.deleteError
          )?.show
        }
        autoHideDuration={6000}
        anchorOrigin={
          stylesGW.ShowsMessagesSuccess.anchorOrigin as
            | SnackbarOrigin
            | undefined
        }
      >
        <Alert
          severity="success"
          variant="filled"
          sx={stylesGW.ShowsMessagesSuccess.alertSucces2}
        >
          {t("Grain_tracker.delete_criteria")}
        </Alert>
      </Snackbar>
    </div>
  );
};
